module.exports = __webpack_public_path__ + "img/point_starting_p.72b083cf.svg";